type RemoteAlias = 'backoffice-remote-brands';

export const hasRemoteInitialized = (remoteAlias: RemoteAlias) =>
  Object.keys(window.__FEDERATION__.moduleInfo).some((key) => key.startsWith(`${remoteAlias}:`));
